import React, { useState, useEffect } from "react";
import {
	BrowserRouter,
	Route,
	Switch,
	Redirect,
	withRouter,
	useHistory,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import messages from '../assets/i18n'
import havePermissionTo from '../utils/havePermission'
import AuthHOC from "./AuthHOC";
import LoginPage from "../pages/LoginPage/LoginPage";
import RegisterPage from "../pages/RegisterPage/RegisterPage";
import LoginSuccessPage from "../pages/LoginSuccessPage/LoginSuccessPage";
import MainPage from "../pages/MainPage/MainPage";
import Load from "../components/Load/Load";
import SchedulingPage from "../pages/SchedulingPage/SchedulingPage";
import ReconcilePage from "../pages/ReconcilePage/ReconcilePage";
import ConciliationResultPage from "../pages/ConciliationResultPage/ConciliationResultPage";
import ConciliationReport from "../pages/ConciliationReport/ConciliationReport";
import SustainabilityCertificatePage from "../pages/SustainabilityCertificatePage/SustainabilityCertificatePage"
import SustainabilityStatusPage from "../pages/SustainabilityStatusPage/SustainabilityStatusPage"
import LoadDetails from "../pages/LoadDetails/LoadDetails"
import Header from "../components/Header/Header";
import CdList from "../pages/CdList/CdList";
import CdDetails from "../pages/CdDetails/CdDetails";
import BoxTagPage from "../pages/BoxTagPage/BoxTagPage";
import PriceTagPage from "../pages/PriceTagPage/PriceTagPage";
import MeasurementChart from "../pages/MeasurementChart/MeasurementChart";
import ProviderListPage from "../pages/ProviderListPage/ProviderListPage"
import ProducerDeclaration from "../pages/ProducerDeclaration/ProducerDeclaration"
import DeclarationList from "../pages/DeclarationList/DeclarationList"
import DeclarationDetails from "../pages/DeclarationDetails/DeclarationDetails"
import NormList from "../pages/NormList/NormList"
import NormDetails from "../pages/NormDetails/NormDetails"
import ProviderDetails from "../pages/ProviderDetails/ProviderDetails"
import SustainabilityList from "../pages/SustainabilityList/SustainabilityList"
import SchedulingReport from "../pages/SchedulingReport/SchedulingReport"
import PreSchedulingReport from "../pages/PreSchedulingReport/PreSchedulingReport"
import PreScheduling from "../pages/PreScheduling/PreScheduling"
import PreSchedulingList from "../pages/PreSchedulingList/PreSchedulingList"
import ConciliationList from "../pages/ConciliationList/ConciliationList"
import SubcontractorList from "../pages/SubcontractorList/SubcontractorList"
import SubcontractorDetails from "../pages/SubcontractorDetails/SubcontractorDetails"
import SubcontractorInvoice from "../pages/SubcontractorInvoice/SubcontractorInvoice"
import OrderSampleList from "../pages/OrderSampleList/OrderSampleList"
import OrderSampleDetails from "../pages/OrderSampleDetails/OrderSampleDetails"
import OrderOptions from "../pages/OrderOptions/OrderOptions"
import IdgfPowerBi from "../pages/IdgfPowerBi/IdgfPowerBi"
import OriginCertificateList from "../pages/OriginCertificateList/OriginCertificateList"
import OriginCertificateUpload from "../pages/OriginCertificateUpload/OriginCertificateUpload"
import { LoadingSpinner } from "../components";
import getQueryParam from '../utils/getQueryParam'
import { slide as Menu } from 'react-burger-menu'
import { Creators as actionLanguage } from '../store/ducks/language'
import "../components/SideBar/SideBar.css";

function PrivateRoute (props) {
	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const { isLoading, status } = useSelector(state => state.authentication);

	let Component = props.component;
	let isLogged = props.isLogged();
	let permissions = props.getPermissions.permissions;
	let currentPage = props.location.pathname.substr(1);

	const havePermission = havePermissionTo(currentPage, permissions);
	const { id } = getQueryParam(window.location.search)

	const history = useHistory();


	const redirectToPage = (url) => {
		setOpen(!isOpen)
		history.push(url);
	}

	const [isOpen, setOpen] = useState(false)

	const handleIsOpen = () => {
	  setOpen(!isOpen)
	}
	
	useEffect(() => {	
		if (lang !== document.documentElement.lang) {
			dispatch(actionLanguage.change(lang))
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lang]);

	return (
		<div>
			<Menu
				isOpen={isOpen}
				onOpen={handleIsOpen}
				onClose={handleIsOpen}>
				{/* eslint-disable jsx-a11y/anchor-is-valid */}
				<a onClick={() => redirectToPage('/main')}>{messages[lang].orderList}</a>

				{havePermissionTo('cd-list', permissions) ?
					<a onClick={() => redirectToPage('/cd-list')}>{messages[lang].cdList}</a>
					:
					null
				}

				{havePermissionTo('provider-list', permissions) ?
					<a onClick={() => redirectToPage('/provider-list')}>{messages[lang].providerList}</a>
					:
					null
				}

				{havePermissionTo('declaration-list', permissions) ?
					<a onClick={() => redirectToPage('/declaration-list')}>{messages[lang].declarationList}</a>
					:
					null
				}

				{havePermissionTo('norm-list', permissions) ?
					<a onClick={() => redirectToPage('/norm-list')}>{messages[lang].normList}</a>
					:
					null
				}

				{havePermissionTo('sustainability-list', permissions) ?
					<a onClick={() => redirectToPage('/sustainability-list')}>{messages[lang].sustainabilityList}</a>
					:
					null
				}

				{havePermissionTo('scheduling-report', permissions) ?
					<a onClick={() => redirectToPage('/scheduling-report')}>{messages[lang].schedulingReport}</a>
					:
					null
				}
				{havePermissionTo('pre-scheduling-report', permissions) ?
					<a onClick={() => redirectToPage('/pre-scheduling-report')}>{messages[lang].preSchedulingReport.title}</a>
					:
					null
				}
				{havePermissionTo('conciliation-report', permissions) ?
					<a onClick={() => redirectToPage('/conciliation-report')}>{messages[lang].conciliationReport}</a>
					:
					null
				}
				{havePermissionTo('conciliation-list', permissions) ?
					<a onClick={() => redirectToPage('/conciliation-list')}>{messages[lang].conciliationList}</a>
					:
					null
				}
				{havePermissionTo('subcontractor-list', permissions) ?
					<a onClick={() => redirectToPage('/subcontractor-list')}>{messages[lang].subcontractorList}</a>
					:
					null
				}
				{havePermissionTo('order-sample-list', permissions) ?
					<a onClick={() => redirectToPage('/order-sample-list')}>{messages[lang].orderSampleList}</a>
					:
					null
				}
				{havePermissionTo('idgf', permissions) ?
					<a onClick={() => redirectToPage('/idgf')}>{messages[lang].idgf}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://painelfornecedor.com.br/sso/renner" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.painelFinanceiro}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://portaldesolucoes.lojasrenner.com.br/fornecedor" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.portalSolucoes}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://portaldesolucoes.lojasrenner.com.br/fornecedor" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.baseConhecimento}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://portaldesolucoes.lojasrenner.com.br/fornecedor" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.noticias}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://lrprod.centricsoftware.com/WebAccess/login.html" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.plm}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://sgsnow.sgs.com/runner" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.sgsNow}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://portalrfid.tycois.com.br/" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.sensormatic}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://www.brasil.mainetti.com/" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.mainetti}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://renner.techsocial.com.br/" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.techsocial}</a>
					:
					null
				}
				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://app.inspectorio.com/" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.inspectorio}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://www.lojasrennersa.com.br/urfornecedores" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.urFornecedores}</a>
					:
					null
				}

				{havePermissionTo('links-fornecedor', permissions) ?
					<a href="https://work.me/g/boUfzHg39/btCMo2SM" rel="noopener noreferrer" target="_blank">{messages[lang].linksFornecedor.workplaceFornecedores}</a>
					:
					null
				}

				{havePermissionTo('origin-certificate', permissions) ?
					<a onClick={() => redirectToPage('/origin-certificate')}>{messages[lang].originCertificate}</a>
					:
					null
				}
				{/* eslint-enable jsx-a11y/anchor-is-valid */}
			</Menu>
			<Header />
			<Route
				render={props =>
					isLoading ? (
						<>
							<h2 className="text-center">
								{messages[lang].loading}
							</h2>
							<LoadingSpinner />
						</>
					) : isLogged && havePermission ? (
						<div>
							<Component
								{...props}
								permissions={permissions}
								isLogged={isLogged}
							/>
						</div>
					) : isLogged && !havePermission ? (
						<h2 className="text-center">
							{messages[lang].withoutPermission}
						</h2>
					) : status === 'login_unauthorized' || (id && status !== 'logged_in') ? (
						<h2 className="text-center">
							{messages[lang].withoutUser}
						</h2>
					) : (
						<Redirect
							to={{
								pathname: "/",
								state: { from: props.location }
							}}
							login={props.login}
							isLogged={isLogged}
						/>
					)
				}
			/>
		</div>
	);
}

const Routes = (props) => {

	const { isLogged, redirect, getPermissions } = props;

	// redirect to the page requested by the HOC
	if (redirect) {
		props.history.push(redirect);
	}

	return (
		<BrowserRouter>
			<Switch>
				<Redirect exact from="/" to="/login" isLogged={isLogged} />
				<Route
					path="/login/success"
					component={() => <LoginSuccessPage></LoginSuccessPage>}
					exact
				/>
				<Route
					path="/login"
					component={() => <LoginPage></LoginPage>}
				/>
				<Route
					path="/register"
					component={RegisterPage}
				/>
				<PrivateRoute
					path="/main"
					component={MainPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/load"
					component={Load}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/scheduling"
					component={SchedulingPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/reconcile"
					component={ReconcilePage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/sustainability"
					component={SustainabilityCertificatePage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/sustainability-status"
					component={SustainabilityStatusPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/conciliation-status"
					component={ConciliationResultPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/load-details"
					component={LoadDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/cd-list"
					component={CdList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/cd-details"
					component={CdDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/box-tag"
					component={BoxTagPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/price-tag"
					component={PriceTagPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/import-chart"
					component={MeasurementChart}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/provider-list"
					component={ProviderListPage}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/producer-declaration"
					component={ProducerDeclaration}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/declaration-list"
					component={DeclarationList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/declaration-details"
					component={DeclarationDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/norm-list"
					component={NormList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/norm-details"
					component={NormDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/sustainability-list"
					component={SustainabilityList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/scheduling-report"
					component={SchedulingReport}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/pre-scheduling-report"
					component={PreSchedulingReport}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/provider-details"
					component={ProviderDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/pre-scheduling-details"
					component={PreScheduling}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/pre-scheduling-list"
					component={PreSchedulingList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/conciliation-report"
					component={ConciliationReport}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/conciliation-list"
					component={ConciliationList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/subcontractor-list"
					component={SubcontractorList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/subcontractor-details"
					component={SubcontractorDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/order-options"
					component={OrderOptions}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/subcontractor-invoice"
					component={SubcontractorInvoice}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/order-sample-list"
					component={OrderSampleList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/order-sample-details"
					component={OrderSampleDetails}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/idgf"
					component={IdgfPowerBi}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/origin-certificate"
					component={OriginCertificateList}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
				<PrivateRoute
					path="/origin-certificate-upload"
					component={OriginCertificateUpload}
					isLogged={isLogged}
					getPermissions={getPermissions}
				/>
			</Switch>
		</BrowserRouter>
	);
}

export default AuthHOC(withRouter(Routes));
